import { useAxios } from '../contexts/axiosContext';

export default function CountryService() {
  const { authAxios } = useAxios();

  function list({ signal } = {}) {
    return new Promise((resolve, reject) => {
      authAxios.get('/countries', { signal })
        .then((resp) => resolve(resp.data))
        .catch((err) => reject(err));
    });
  }

  return { list };
}